export default "__VITE_ASSET__CsndUWB9__"